<!--签到活动-->
<template>
  <div id="signInActivity" :style="{'height':'calc(100vh - ' + topBarHeight +'px)','padding-top':topBarHeight+'px'}">
    <div style="position:relative;width:100%;height:100%;padding-top:90px;">
      <!--背景图区-->
      <div style="">
        <img src="../../../assets/Event/SignInActivity/background.png" style="position:absolute;top:8px;right:15px;width:118px;">
      </div>
      <!--已连续签到 文字-->
      <div style="position:absolute;top:28px;left:5px;font-size:24px;font-weight:bold;
      background: linear-gradient(135deg, rgba(74, 154, 255, 1) 0%, rgba(134, 180, 255, 1) 19.55%, rgba(39, 141, 255, 1) 52.93%, rgba(61, 196, 255, 1) 80.64%, rgba(92, 222, 255, 1) 100%);
      -webkit-background-clip: text;-webkit-text-fill-color: transparent;">
        <p>已连续签到 <span style="font-size:36px;">{{hasSignInNumber}}</span> 天</p>
      </div>
      <!--日历区-->
      <div style="position:relative;width:100%;height:370px;">
        <img src="../../../assets/Event/SignInActivity/border.png" style="position:absolute;top:0;left:0;width:100%;height:100%;">
        <div style="position:absolute;top:0;left:0;width:100%;height:100%;">
          <div style="height:40px;margin-top:5px;padding-left:18px;">
            <p style="line-height:40px;font-size:12px;background: linear-gradient(135deg, rgba(74, 154, 255, 1) 0%, rgba(134, 180, 255, 1) 19.55%, rgba(39, 141, 255, 1) 52.93%, rgba(61, 196, 255, 1) 80.64%, rgba(92, 222, 255, 1) 100%);
          -webkit-background-clip: text;-webkit-text-fill-color: transparent;">每周签到领福利</p>
          </div>
          <div style="width:calc(100% - 36px);height:calc(100% - 45px - 42px);padding:21px 18px;">
            <div style="width:100%;height:100px;display:flex;justify-content: space-between;">
              <div v-for="(item,index) in dayInfoList.slice(0,4)" :key="'line1'+index" style="width:calc(25% - 8px);height:100%;background:rgba(75, 95, 123, 0.2);border-radius:12px;display:flex;flex-direction:column;align-items: center;justify-content: center;">
                <img v-if="index >= hasSignInNumber" src="../../../assets/Event/SignInActivity/itemImage.png" style="height:38px;">
                <img v-if="index < hasSignInNumber" src="../../../assets/Event/SignInActivity/itemImage_signin.png" style="height:38px;">
                <p style="margin-top:5px;color:rgba(52, 175, 255, 1);font-size:14px;text-align:center;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">{{index >= hasSignInNumber ? item.text : '已签'}}</p>
              </div>
            </div>
            <div style="width:100%;height:100px;margin-top:12px;display:flex;justify-content: space-between;">
              <div v-for="(item,index) in dayInfoList.slice(4,7)" :key="'line2'+index" :style="{'width':index === 2 ? 'calc((25% - 8px) * 2 + (100% - (25% - 8px) * 4) / 3)' : 'calc(25% - 8px)'}"
                   style="width:calc(25% - 8px);height:100%;background:rgba(75, 95, 123, 0.2);border-radius:12px;display:flex;flex-direction:column;align-items: center;justify-content: center;">
                <img v-if="index >= hasSignInNumber - 4" src="../../../assets/Event/SignInActivity/itemImage.png" style="height:38px;">
                <img v-if="index < hasSignInNumber - 4" src="../../../assets/Event/SignInActivity/itemImage_signin.png" style="height:38px;">
                <p style="margin-top:5px;color:rgba(52, 175, 255, 1);font-size:14px;text-align:center;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">{{index >= hasSignInNumber - 4 ? item.text : '已签'}}</p>
              </div>
            </div>
            <div style="position:relative;width: calc(100% + 20px);height: 72px;margin-top: 10px;margin-left: -10px;">
              <img src="../../../assets/Event/SignInActivity/signInBtn.png" style="position:absolute;top:0;left:0;width:100%;height:100%;">
              <p v-if="couldSignIn" @click="signIn" style="position:absolute;top:0;left:0;width:100%;height:100%;line-height:68px;
              text-align:center;font-size:16px;background: linear-gradient(135deg, rgba(74, 154, 255, 1) 0%, rgba(134, 180, 255, 1) 19.55%, rgba(39, 141, 255, 1) 52.93%, rgba(61, 196, 255, 1) 80.64%, rgba(92, 222, 255, 1) 100%);
              -webkit-background-clip: text;-webkit-text-fill-color: transparent;">{{btnText}}</p>
              <p v-if="!couldSignIn" style="position:absolute;top:0;left:0;width:100%;height:100%;line-height:68px;text-align:center;font-size:16px;color:rgba(128, 128, 128, 1);">今日已签到</p>
            </div>
          </div>
        </div>
      </div>
      <!--规则说明区-->
      <div @click="ruleOpen = !ruleOpen;" style="width: 90px;margin-top:15px;">
        <p style="font-size:16px;color:rgba(128, 128, 128, 1);">签到规则
          <span class="iconfontFamily" style="font-size: 14px;">{{ruleOpen ? '&#xe78f;' : '&#xe788;'}}</span>
        </p>
      </div>
      <div v-if="ruleOpen" style="width:100%;height:calc(100% - 90px - 370px - 60px);margin-top:11px;font-size:14px;color:rgba(128, 128, 128, 1);" class="myScrollAreaWidthoutThumb">
        <p>活动时间：</p>
        <p>{{rule_activityTime}}</p>
        <p style="margin-top:10px;">参与条件：</p>
        <p>1.须为共生地球APP注册用户。</p>
        <p style="margin-top:10px;">参与方式：</p>
        <p>1.活动时间内，符合参与条件的用户登录共生地球APP，点击首页-菜单-活动，进入本活动页面，根据页面提示即有机会参与本活动。</p>
        <p>2.用户参与本活动所需APP已更新至最新版本。</p>
        <p>3.{{rule_joinMethod}}</p>
        <p>4.如遇权益发放失败可截图保存后，重启APP。如仍发放失败可联系共生地球客服，凭截图信息进行协商解决。</p>
        <p style="margin-top:10px;">权益生效：</p>
        <p>签到完成后，线上权益将立即生效，如有线下奖品请等待运营人员与您沟通进行发放。</p>
        <p style="margin-top:10px;">注意事项：</p>
        <p>1.若用户存在账号作弊（如使用外挂、多账号刷签到等）、恶意刷取权益等违规行为，APP运营方有权取消其活动参与资格及已获得的会员权益，且不予以补偿。</p>
        <p>2.签到数据以共生地球APP系统记录为准，因网络延迟、设备故障等非用户原因导致的签到异常，可联系 共生地球小助手 提供截图反馈，经核实后可协助补录。</p>
        <p>3.签到权益生效后，若账号因违规被封禁，会员权益将同步冻结，封禁期间会员有效期不予顺延。</p>
        <p style="margin-top:10px;">本活动规则最终解释权归共生地球APP运营团队所有，如有疑问可通过客服渠道咨询（工作日 8:30-17:30）</p>
      </div>
    </div>

    <!--toast提示-->
    <div v-if="toastShow" style="position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);height:133px;padding:0 34px;border-radius:28px;background:rgba(56, 56, 56, 0.5);backdrop-filter: blur(4px);display:flex;flex-direction:column;align-items:center;justify-content:center;">
      <p style="color:rgba(229, 229, 229, 1);font-size:20px;" class="iconfontFamily">&#xe741;</p>
      <p style="margin-top:9px;text-align:center;color:rgba(255, 255, 255, 1);font-size:16px;">{{toastText}}</p>
    </div>

    <div v-if="toastErrorShow" style="position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);height:133px;padding:0 34px;border-radius:28px;background:rgba(56, 56, 56, 0.5);backdrop-filter: blur(4px);display:flex;flex-direction:column;align-items:center;justify-content:center;">
      <p style="color:rgba(229, 229, 229, 1);font-size:20px;" class="iconfontFamily">&#xe623;</p>
      <p style="margin-top:9px;text-align:center;color:rgba(255, 255, 255, 1);font-size:16px;">签到失败</p>
    </div>

  </div>

</template>

<script>
export default {
  name: "SignInActivity",
  data(){
    return{
      topBarHeight:86,

      ruleOpen:true,

      //已签到天数
      hasSignInNumber:0,
      //当前能否签到
      couldSignIn:false,
      //天信息
      dayInfoList:[],
      //签到按钮文字
      btnText:"",
      //活动规则：活动时间
      rule_activityTime:"",
      //活动规则：参与方式
      rule_joinMethod:"",


      //toast
      toastShow:false,
      toastText:"",
      toastErrorShow:false,


      //token
      token:"",

    }
  },
  methods:{

    //获取签到状态、日历表等信息
    getActivityData(){
      this.$http.get("/earthApi/sign-record/getSignRecordByUserId", {headers:{'Authorization': 'Bearer ' + this.token}}).then(response => {
        if(response.body.status === 200){
          console.log(response.body.data)
          this.hasSignInNumber = response.body.data.currentStreak;
          this.couldSignIn =  !response.body.data.todaySigned;
        }
      })
      this.$http.get("/earthApi/sign-record/getSignCalendar", {headers:{'Authorization': 'Bearer ' + this.token}}).then(response => {
        if(response.body.status === 200){
          console.log(response.body.data)
          this.dayInfoList = response.body.data;
        }
      })
      this.$http.get("/earthApi/sign-record/getSignTextInfo").then(response => {
        if(response.body.status === 200){
          console.log(response.body.data)
          for(let i=0;i<response.body.data.length;i++){
            console.log(response.body.data[i])
            let key = Object.keys(response.body.data[i])[0]
            switch(key){
              case "buttonText":{
                this.btnText = response.body.data[i][key]
                break;
              }
              case "activityTime":{
                this.rule_activityTime = response.body.data[i][key]
                break;
              }
              case "joinInWay":{
                this.rule_joinMethod = response.body.data[i][key]
                break;
              }
            }
          }
        }
      })
    },

    //签到
    signIn(){
      if(this.couldSignIn){

        this.$http.post("/earthApi/sign-record/addSignRecord", new FormData(), {headers:{'Authorization': 'Bearer ' + this.token}}).then(response => {
          if(response.body.status === 200){
            console.log(response.body.data)
            if(this.dayInfoList[this.hasSignInNumber].hasReward){
              this.toastText = "权益已发放"
            }
            else{
              this.toastText = "签到成功"
            }
            this.couldSignIn = false;
            this.hasSignInNumber ++;

            this.toastShow = true;
            setTimeout(()=>{
              this.toastShow = false;
            },3000)
          }
          else{
            //签到失败
            this.toastErrorShow= true;
            setTimeout(()=>{
              this.toastErrorShow = false;
            },3000)
          }
        })
      }
    },


    //获取app端手机型号的顶栏高度，加一个合适的值，设为页面的paddingTop
    getTopBarHeight(value){
      this.topBarHeight = value;
    }


  },

  mounted(){
    window.activityH5Page = this;
    if(window["flutter_backActivityInfo"]){
      window["flutter_backActivityInfo"].postMessage(JSON.stringify({title:"每周签到"}));
    }
    if(this.$route.query.appToken){
      this.token = this.$route.query.appToken
    }
    console.log(this.token)
    this.getActivityData();
  }


}
</script>

<style scoped>

#signInActivity{
  position:fixed;
  top:0;
  left:0;
  width:calc(100vw - 40px);
  background:rgba(2, 15, 31, 1);
  padding-left:20px;
  padding-right:20px;
}
#signInActivity p{
  margin:0;
}


/*滚动条样式*/
.myScrollAreaWidthoutThumb{
  overflow:auto;
}
.myScrollAreaWidthoutThumb::-webkit-scrollbar-track-piece{
  -webkit-border-radius:0;
}
.myScrollAreaWidthoutThumb::-webkit-scrollbar{
  width:0;
}
.myScrollAreaWidthoutThumb::-webkit-scrollbar-thumb{
  background-color: rgba(120, 120, 120, 1);
  -webkit-border-radius:1px;
  border: 1px solid rgba(120, 120, 120, 1);
}

</style>